import { Controller } from "@hotwired/stimulus"

// Polls IssuesController#refresh for a fresh render of the issue table (or its empty state), on a
// fixed interval: unlike live_chart_controller.js, there's no range picker here, just one
// cadence, since a status/count showing up a few seconds late is the whole ask, not a tunable
// time window. The current filters, sort, and page are never read off this element's own dataset:
// window.location.search already has all of it (see issues/index.html.erb), so a poll just
// re-requests the exact page the visitor is looking at and swaps in whatever comes back.
const POLL_INTERVAL_MS = 10000

export default class extends Controller {
  static values = { url: String }
  static targets = ["content"]

  connect() {
    this.timer = setInterval(() => this.refresh(), POLL_INTERVAL_MS)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  // Same reasoning as live_chart_controller.js's own refresh: a poll the tab can't see is a query
  // spent on a table nobody's looking at, and a failed request (a deploy, a network blip) isn't
  // worth surfacing for a background refresh of an already-rendered list; the next tick retries.
  async refresh() {
    if (document.hidden) return

    try {
      const response = await fetch(`${this.urlValue}${window.location.search}`, { headers: { Accept: "text/html" } })
      if (response.ok) this.contentTarget.innerHTML = await response.text()
    } catch {
      // See comment above: a dropped poll isn't worth doing anything about.
    }
  }
}
